import styled from "styled-components";
import tw from "twin.macro";
import { DP } from "../../common/types";
import { createFormValidation } from "../../context/createFormValidation";
import { createCustomStore } from "../../context/customStore";
import { defaultValidateRules, IRules } from "../../hooks/useFormValidation";
import { fetchSubmit } from "./api";
import Input from "./components/Input";
import SubmitButton from "./components/SubmitButton";
import useGoogleAuthEffect from "./hooks/useGoogleAuthEffect";

export interface IInitFields {
  email: string;
  password: string;
}

const initFields: IInitFields = {
  email: "",
  password: "",
};

const rules: IRules<IInitFields> = {
  email: [
    defaultValidateRules.required(),
    {
      isValid: (value) => new RegExp(/\w+@\w+\.\w+/).test(value),
      errorMessage: "Invalid format",
    },
  ],
  password: [defaultValidateRules.setMinLength(6)],
};

export const { useValue: useLoginStore, set: setLoginStore } =
  createCustomStore({ loginFormVisibility: false, isLoading: false });

export const {
  setField,
  useFieldError,
  useFieldValue,
  isFieldsValid,
  getFields,
} = createFormValidation(initFields, rules);

const Login = ({ className }: DP) => {
  const loginFormVisibility = useLoginStore((s) => s.loginFormVisibility);
  const isLoading = useLoginStore((s) => s.isLoading);

  useGoogleAuthEffect(loginFormVisibility, fetchSubmit);

  const handleHide = (e) => {
    if (e.target === e.currentTarget) {
      setLoginStore({ loginFormVisibility: false });
    }
  };

  if (!loginFormVisibility) return null;

  return (
    <Wrapper onClick={handleHide} className={className}>
      <Form>
        <Input disabled={isLoading} fieldName={"email"} />
        <Input disabled={isLoading} fieldName={"password"} />
        <SubmitButton disabled={isLoading} />
        <GoogleWrapper id="googleBtn"></GoogleWrapper>
      </Form>
    </Wrapper>
  );
};

const Wrapper = styled.div(() => [
  tw`absolute top-0 bg-[rgba(0, 0, 0, 0.3)] bottom-0 left-0 right-0 z-10 flex items-center justify-center`,
]);

const Form = styled.form(() => [
  tw`box-content p-5 space-y-1 bg-white rounded-lg`,
  tw`m-1 md:(w-[10rem])`,
]);

const GoogleWrapper = styled.div(() => [tw`flex justify-center h-3`]);

export default styled(Login)``;
